import List from './list/InsuranceNetworkListInitialState'

const { Record } = require('immutable')

const InitialState = Record({
    list: List()
})

export default InitialState